export const reasonOptions = [
  { label: 'Prestator', value: 'PROVIDER' },
  { label: 'Transportator', value: 'TRANSPORTER' },
  { label: 'Sef depozit', value: 'SHOP' }
]

export const getInitialValues = (scanCodeData, offlineData) => ({
  defect: offlineData?.offlineDefect ?? scanCodeData?.defect,
  reason: offlineData?.offlineReason ?? scanCodeData?.reason,
  supportId: scanCodeData?.supportId,
  supportTypeId: offlineData?.offlineSupportTypeId ?? scanCodeData?.supportTypeId,
  nonCompliantReasonList: offlineData?.offlineNonCompliantReasonList
})

export const toSupportHubPayload = values => ({
  ...values,
  nonCompliantReasonList: values.nonCompliantReasonList?.map(reason => reason.value)
})

export const markOptions = [
  { label: 'Legume fructe', value: 'VEGETABLES_FRUITS' },
  { label: 'Deteriorate', value: 'DAMAGED' },
  { label: 'Termen Scurt', value: 'SHORT_TERM' },
  { label: 'Expirate', value: 'EXPIRED' },
  { label: 'Calitate legume fructe', value: 'VEGETABLE_FRUIT_QUALITY' },
  { label: 'Deteriorare-A', value: 'DETERIORATION_A' },
  { label: 'Diferenta cantitativa-A', value: 'QUANTITATIVE_DIFFERENCE_A' },
  { label: 'Lipsa Bax', value: 'MISSING_BAX' },
  { label: 'Diferenta cantitativa', value: 'QUANTITATIVE_DIFFERENCE' },
  { label: 'Lipsa transportator', value: 'MISSING_CARRIER' },
  { label: 'Paleti marfa lipsa', value: 'PALLETS_MERCHANDISE_MISSING' },
  { label: 'VOL', value: 'VOLUME' }
]
